export default __webpack_public_path__ + "static/media/DTE.dd10f7e1.mp4";